import { GridFilterItem } from '@mui/x-data-grid-pro';
import { filterObject } from '@src/types/Archivist';
import { FilterField, FilterState, FILTER_FIELDS } from './types';

export const getDependentFields = (field: FilterField): FilterField[] => {
  const fieldIndex = FILTER_FIELDS.indexOf(field);
  return FILTER_FIELDS.slice(fieldIndex + 1);
};

export const buildFilterArray = (
  filters: FilterState,
  upToField?: FilterField,
): filterObject[] => {
  const result: filterObject[] = [{ field: 'isParsed', value: 'true' }];

  for (const field of FILTER_FIELDS) {
    if (upToField && field === upToField) {
      break;
    }
    if (filters[field]) {
      result.push({ field, value: filters[field] });
    }
  }

  return result;
};

export const hasActiveFilters = (filters: FilterState): boolean =>
  FILTER_FIELDS.some((field) => filters[field] !== '');

export const formatCategoryDisplay = (value: string): string => {
  if (!value) {
    return '';
  }
  return value
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
    .toUpperCase();
};

const convertFilterValue = (value: unknown): string | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  if (Array.isArray(value)) {
    return value.filter((v) => v !== null && v !== undefined).join(',');
  }
  return null;
};

export const gridFiltersToFilterObjects = (
  gridFilters: GridFilterItem[],
): filterObject[] =>
  gridFilters
    .map((item) => {
      const value = convertFilterValue(item.value);
      return value !== null ? { field: item.field, value } : null;
    })
    .filter((item): item is filterObject => item !== null);

export const mergeFilters = (
  cascadeFilters: filterObject[],
  gridFilters: filterObject[],
): filterObject[] => {
  const cascadeFieldSet = new Set(cascadeFilters.map((f) => f.field));
  const uniqueGridFilters = gridFilters.filter(
    (f) => !cascadeFieldSet.has(f.field),
  );
  return [...cascadeFilters, ...uniqueGridFilters];
};
